var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"BE-termsCond",domProps:{"innerHTML":_vm._s(_vm.$store.state.TermsAndConditions)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-879095ae","hasScoped":false,"buble":{"transforms":{}}}!./src/components/termsAndConditions/termsAndConditions.template.html
// module id = 293
// module chunks = 0